import ChangeColorInput from "./ChangeColorInput";
import LogoInput from "./LogoInput";
import CustomButton from "@/components/CustomButton";
import useAdminConsole from "./useAdminConsole";

const AdminConsole = () => {
  const {
    primaryColor,
    setPrimaryColor,
    secondaryColor,
    setSecondaryColor,
    logo,
    setLogo,
    handleSubmit,
    handleRestoreDefaults,
    isPending,
  } = useAdminConsole();

  const submitHandler = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    handleSubmit();
  };

  return (
    <form onSubmit={submitHandler} className="flex flex-col gap-4 lg:w-1/2">
      <LogoInput logo={logo} setLogo={setLogo} />
      <div className="flex flex-col justify-between gap-4">
        <ChangeColorInput isSecondary={false} value={primaryColor} setValue={setPrimaryColor} />
        <ChangeColorInput isSecondary={true} value={secondaryColor} setValue={setSecondaryColor} />
      </div>
      <div className="flex gap-4 pt-4">
        <CustomButton variant="primary" text="Save" disabled={isPending} />
        <CustomButton
          variant="default"
          text="Restore Defaults"
          type="button"
          disabled={isPending}
          onClickHandler={handleRestoreDefaults}
        />
      </div>
    </form>
  );
};

export default AdminConsole;
